import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { CarDetailsQueryKeys } from "modules/CarDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { CarNote } from "models";

const handleUpdateCarNoteOnAppointment = (payload: CarNote) => {
  const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
  if (!appointment?.car?.notes) return;

  const carNoteIdx = appointment.car.notes.findIndex(note => note.id === payload.id);
  if (carNoteIdx === -1) return;

  typedQueryClient.setQueryData(AppointmentDetailsKeys.view, {
    ...appointment,
    car: { ...appointment.car, notes: appointment.car.notes.with(carNoteIdx, { ...appointment.car.notes[carNoteIdx], ...payload }) }
  });
};

const handleUpdateCarNoteOnCar = (payload: CarNote) => {
  const car = typedQueryClient.getQueryData(CarDetailsQueryKeys.details);
  if (!car?.notes) return;

  const carNoteIdx = car.notes.findIndex(note => note.id === payload.id);
  if (carNoteIdx === -1) return;

  typedQueryClient.setQueryData(CarDetailsQueryKeys.details, { ...car, notes: car.notes.with(carNoteIdx, { ...car.notes[carNoteIdx], ...payload }) });
};

export const useUpdateCarNoteMutation = () =>
  useTypedMutation<CarNote, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/notes/update", payload, ENV.carBaseURL);
    },
    onSuccess: payload => {
      handleUpdateCarNoteOnCar(payload);
      handleUpdateCarNoteOnAppointment(payload);
    }
  });
